import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

$(function() {
    const $page = $('.MultipleDealsPage_WebinarPackage .wp');
    if (!$page.length) return;

    const closeOthers = function(selector) {
        $page.on('show.bs.collapse', selector, function(e) {
            if (e.target !== this) return;
            $page.find(selector).filter('.in').not(this).collapse('hide');
        });
    };

    closeOthers('.pkg-item-detail');
    closeOthers('.pkg-list');

    $page.find('.js-wp-offer-until').each(function() {
        const msTimestamp = parseInt($(this).data('mstimestamp'));
        if (isNaN(msTimestamp) || msTimestamp <= Date.now()) {
            $(this).remove();
        }
    });

    const $buybar = $page.find('.sp-buybar');
    const $mainButton = $page.find('.pkg--featured .pkg-form .btn').first();
    if ($buybar.length && $mainButton.length) {
        $buybar.find('.js-wp-buybar-enroll').on('click', function(e) {
            e.preventDefault();

            // The main card's course dropdown is off screen, so bring it into view instead of failing silently
            const $form = $mainButton.closest('form');
            const $courseSelect = $form.find('select[name=OptionalCourses1]');
            if ($courseSelect.length && !$courseSelect.val()) {
                $form.find('.js-optionalCourseValidation').show();
                const $target = $('#ComboPurchaseForm_ComboPurchaseForm');
                ($target.length ? $target : $form)[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                $courseSelect[0].focus({ preventScroll: true });
                return;
            }

            // Native click so links navigate and form buttons submit; jQuery's trigger() does not follow an <a href>
            $mainButton[0].click();
        });

        const toggleBuybar = function() {
            const buttonBottom = $mainButton[0].getBoundingClientRect().bottom;
            $buybar.toggleClass('is-visible', buttonBottom < 0);
        };

        $(window).on('scroll resize', toggleBuybar);
        toggleBuybar();
    }
});



// WEBPACK FOOTER //
// ./js/modules/webinarPackage.js